/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StockUpdateHistoryApi } from '../api/stockupdatehistory.api';
import { switchMap, map } from 'rxjs/operators';
import { StockUpdateHistoryData, StockUpdateHistory } from '../../../interfaces/masters/stockupdatehistory';

@Injectable()
export class StockUpdateHistoryService extends StockUpdateHistoryData {

  constructor(private api: StockUpdateHistoryApi) {
    super();
  }



  list(url: string): Observable<StockUpdateHistory[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<StockUpdateHistory>{
      return this.api.getById(url);
  }

  create(url: string, data:StockUpdateHistory): Observable<StockUpdateHistory> {
    return this.api.add(url,data);
  }

  update(url: string, data:StockUpdateHistory): Observable<StockUpdateHistory> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
  searchForMultiBranch(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }
}
